<template>
  <div class="row">
    <div class="col-12 col-md-11 col-lg-8 offset-md-1 offset-lg-2">
      <p class="title center-sm">Familienrecht</p>
      <p class="mt-5">Auch in Angelegenheiten aus dem Familienrecht können Sie sich gerne an mich wenden, insbesondere bei</p>
      <ul class="margin-sm">
        <li>Trennung,</li>
        <li>Scheidung,</li>
        <li>Trennungsunterhalt,</li>
        <li>nachehelichem Unterhalt,</li>
        <li>Kindesunterhalt,</li>
        <li>Sorgerecht,</li>
        <li>Versorgungsausgleich,</li>
        <li>Zugewinnausgleich,</li>
        <li>Aufteilung oder Zuweisung der Ehewohnung oder</li>
        <li>Gewaltschutzsachen.</li>
      </ul>
    </div>
    <div class="col-12 col-md-8 col-lg-8 offset-md-1 offset-lg-2 mt-5">
      <p class="center-sm">Weitere Schwerpunkte:</p>
      <ul class="fields-of-law margin-sm">
        <li><a @click.prevent="$emit('routeTo', 'lot')" href="#">Mietrecht</a></li>
        <li><a @click.prevent="$emit('routeTo', 'cl')" href="#">Strafrecht</a></li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "FamilyLaw.vue"
}
</script>

<style scoped>

</style>